import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { ButtonBase, Grid } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppTab from "../../components/Common/AppTab.js";
import Label from "../../components/Common/Label.js";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import PopOverFilter from "../../components/Common/PopoverFilter";
import SearchBar from "../../components/Common/Searchbar.js";
import Table from "../../components/Common/Table.js";
import TablePageControl from "../../components/Common/TablePageControl.js";
import CustomButton from "../../components/Form/CustomButton.js";
import CustomSelect2 from "../../components/Form/CustomSelect2.js";
import Helpers from "../../helpers/helpers.js";
import { changeSidebarType, getAdvertListing, resetAdvertState } from "../../store/actions.js";
import LoanApplicationDetails from "./LoanApplicationDetails.js";
import CustomizedDatePicker from "../../components/Form/DatePicker.js";

const LoanApplications = ({ userPermission, advertListing, leftSideBarType, editAdvert, financeCompanies, width, makeList, modelList, applicants, isDirectSeller }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetAdvertState());
        if (width <= 768) {
            dispatch(changeSidebarType("condensed", true));
        }

    }, []);

    const [loading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("id");
    const [selectedIds, setSelectedIds] = useState();
    const [selectedRow, setSelectedRow] = useState([]);
    const [minLoanAmount, setMinLoanAmount] = useState("");
    const [maxLoanAmount, setMaxLoanAmount] = useState("");
    const [detailsOpen, setDetailsOpen] = useState(false);

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const searchRef = useRef(search);

    //filter
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', bannerType: 'all', advert_type: ["all"], make: [], model: [], bike_type: [], licenseCategory: [] });


    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by]);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (advertListing?.data) {
            setIsLoading(false);
        }
    }, [advertListing]);

    const header = [
        {
            Header: "Ref No.",
            columnID: "reference_no",
            accessor: (cellProps) => {
                return (<div className="d-flex flex-column">{cellProps?.reference_no || '-'}
                    <span className="text-muted">{cellProps?.application_id}</span></div>)
            },
        },
        {
            Header: "Applicant",
            accessor: (cellProps) => {
                return (<div className="d-flex">{cellProps?.applicant?.name || cellProps?.applicant_name || '-'}</div>)
            },
        },
        {
            Header: "Vehicle",
            minWidth: 200,
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex">
                            <div>
                                <div>{cellProps?.vehicle || cellProps?.listing_title || '-'}</div>
                                <div className="subheader-2">{cellProps?.dealer_name || '-'}</div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Est. Loan Amount",
            accessor: (cellProps) => {
                return (<>{cellProps?.loan_amount != null ? `$${Number(cellProps.loan_amount).toLocaleString()}` : "-"}</>)
            },
        },
        {
            Header: "Finance Company",
            accessor: (cellProps) => {
                return (<>{cellProps?.finance_company || cellProps?.finance_company_name || "-"}</>)
            },
        },
        {
            Header: "Submitted On",
            accessor: (cellProps) => {
                return (<>{cellProps?.submitted_at ? moment(cellProps.submitted_at).format("DD MMM YYYY") : "-"}</>)
            },
        },
        {
            Header: "Status",
            accessor: (cellProps) => {
                return (<><Label.GeneralStatusLabel label={cellProps?.status} list={Helpers.loanApplicationStatus} marginLeft={"0px"} /></>)
            },
        },
    ]

    const tabList = [
        { value: 'published', label: `Submitted (${advertListing?.counts?.submitted || 0})` },
        { value: 'reserved', label: `Approved (${advertListing?.counts?.approved || 0})` },
        { value: 'sold', label: `Rejected (${advertListing?.counts?.rejected || 0})` },
        { value: 'all', label: `All (${advertListing?.counts?.all || 0})` },
    ];

    const initData = () => {
        setIsLoading(true);
        dispatch(getAdvertListing({
            length: length || "",
            page: page || "",
            search: searchRef.current || "",
            tab: tabValue,
            bike_make_ids: filterObject?.bike_make_ids || [],
            bike_model_ids: filterObject?.bike_model_ids || [],
            finance_company_id: filterObject?.finance_company_id || "",
            user_id: filterObject?.user_id || "",
            submission_date_from: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            submission_date_to: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
            loan_amount_min: minLoanAmount || "",
            loan_amount_max: maxLoanAmount || "",
            sort: sort || "",
            sort_by: sort_by || "",
        }))
    }

    const resetFilter = () => {
        setFilterObject({ status: "all", advert_type: ['all'], make: [], model: [], bike_type: [], licenseCategory: [] });
        setStartDate("");
        setEndDate("");
        setSearch(""); // Clear search keyword
        searchRef.current = ""; // Update searchRef
        setPage(page === 1 ? '1' : 1);
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value,
        }));
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));
    };

    const filterList2 = [
        {
            label: "Vehicle Make",
            value: filterObject?.bike_make_ids || [],
            type: "checkbox",
            multiple: true,
            data: makeList || [],
            placeholder: "Any",
            labelName: "name",
            valueName: "id",
            onChange: (e) => {
                setFilterObject({ ...filterObject, bike_make_ids: e })
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
        {
            label: "Vehicle Model",
            value: filterObject?.bike_model_ids || [],
            type: "checkbox",
            multiple: true,
            data: modelList || [],
            placeholder: "Any",
            labelName: "name",
            valueName: "id",
            onChange: (e) => {
                setFilterObject({ ...filterObject, bike_model_ids: e })
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
        {
            label: "Finance Company",
            value: filterObject?.finance_company_id || "",
            type: "checkbox",
            multiple: false,
            data: financeCompanies || [],
            placeholder: "Any",
            labelName: "company_name",
            valueName: "id",
            onChange: (e) => {
                setFilterObject({ ...filterObject, finance_company_id: e?.id ?? e ?? "" })
            },
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
        {
            label: "Applicant",
            value: filterObject?.user_id || "",
            type: "checkbox",
            multiple: false,
            data: applicants || [],
            placeholder: "Any",
            labelName: "name",
            valueName: "id",
            onChange: (e) => setFilterObject({ ...filterObject, user_id: e?.id ?? e ?? "" }),
            xsGrid: 12, smGrid: 12, mdGrid: 12
        },
        {
            label: "Submission Date",
            value: filterObject?.month || [],
            type: "date_range",
            placeholder: "dd/mm/yyyy",
            startDateTitle: "",
            startDate: startDate,
            setStartDate: setStartDate,
            endDateTitle: "",
            endDate: endDate,
            setEndDate: setEndDate,
            xsGrid: 12, smGrid: 12, mdGrid: 12

        },
        {
            type: "loan_amount",
            label: "Loan Amount",
            minValue: minLoanAmount,
            maxValue: maxLoanAmount,
            minPlaceholder: "0",
            maxPlaceholder: "0",
            setMinAmount: (value) => setMinLoanAmount(value),
            setMaxAmount: (value) => setMaxLoanAmount(value),
            xsGrid: 12,
            smGrid: 12,
            mdGrid: 12,
        },
    ]

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || 'id');
        setSorted(sort || 'desc');
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }
    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage(page === 1 ? '1' : 1);
            }
        }, Helpers.searchInterval);
    }

    const handleTabChange = (value) => {
        setTabValue(value);
        setPage(page === 1 ? '1' : 1);
        // setStartSelecting(false);
        setSelectedIds([]);
        setSelectedRow([]);
    }


    const quotationDatePickerSx = {
        height: "36px",
        marginTop: "-5px",
        padding: "0 12px 0 20px",
        justifyContent: "center",
        border: "1px solid #c4c4c4",
        borderRadius: "20px",
        backgroundColor: "#FFFFFF",
        "&:focus-within": {
            borderColor: "#D9D9D9",
        },
        "& .MuiInputBase-root": {
            minHeight: "36px",
        },
        "& .MuiInputBase-input": {
            padding: "8px 0",
            fontSize: 14,
            "&::placeholder": {
                color: "#BDBDBD",
                opacity: 1,
            },
        },
        "& .MuiIconButton-root": {
            color: "#7D7D7D",
        },
    };

    const handleCreatedDateFilterChange = (field, value) => {
        const formattedDate = value && moment(value).isValid()
            ? moment(value).format("YYYY-MM-DD")
            : "";
        const nextFilters = { ...filterObject, [field]: formattedDate };

        if (field === "created_date_from") setStartDate(value || "");
        if (field === "created_date_to") setEndDate(value || "");
        setFilterObject(nextFilters);
        setPage((prevPage) => (prevPage === 1 ? '1' : 1));

    };


    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={9} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={4} md={4} xs={12}>
                        <SearchBar
                            value={search}
                            module={'make, model, title, or reg. no'}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item className="d-flex" lg={4} md={4} xs={12} mt={"6px"}>
                        <div className="d-flex align-items-center gap-1">
                            <CustomizedDatePicker
                                values={startDate && new Date(startDate)}
                                // title={"Created Date from"}
                                placeholder={"Created Date From"}
                                setFormValues={(value) => handleCreatedDateFilterChange("created_date_from", value)}
                                containerSx={quotationDatePickerSx}
                            />
                            <CustomizedDatePicker
                                // title={"Created Date to"}
                                values={endDate && new Date(endDate)}
                                setFormValues={(value) => handleCreatedDateFilterChange("created_date_to", value)}
                                placeholder={"Created Date To"}
                                minDate={startDate && new Date(startDate)}
                                containerSx={quotationDatePickerSx}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <PopOverFilter
                            setDialogOpen={setDrawerOpen}
                            open={drawerOpen}
                            applyFilter={applyFilter}
                            filterData={filterList2}
                            setFilterObject={setFilterObject}
                            sort={sort} sort_by={sort_by}
                            handleResetFilter={resetFilter}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header-2 d-flex align-items-center">Listing <div className="header-amount mx-2">{advertListing?.data?.total || 0}</div></div>
                {
                    creatable &&
                    <CustomButton
                        title={<><i className="ri-add-line" style={{ marginRight: '5px' }} />Create new ad</>}
                        borderStyle={'1px solid #101010'}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        press={() => navigate('/add-advert')}
                        padding={20}
                    />
                }
            </div>
        )
    }

    const formatLoanAmount = (amount) => {
        return amount != null ? `$${Number(amount).toLocaleString()}` : "-";
    }

    const formatSubmittedDate = (date) => {
        return date ? moment(date).format("DD MMM YYYY") : "-";
    }

    const mobileView = () => {
        return (
            <div>
                <AppTab tabValue={tabValue} setTabValue={handleTabChange}
                    tabList={
                        isDirectSeller
                            ? [
                                ...tabList.slice(0, -1), // Everything except the last 2 items
                                {
                                    value: "appealed",
                                    label: `Appealed (${advertListing?.counts?.appealed || 0})`,
                                },
                                {
                                    value: "rejected",
                                    label: `Rejected (${advertListing?.counts?.rejected || 0})`,
                                },
                                ...tabList.slice(-1), // Last 2 items
                            ]
                            : tabList
                    }
                />
                <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                    <div className="d-flex align-items-cente text-semibold font-size-16">{advertListing?.data?.total || 0} Listings</div>
                    <ButtonBase style={{ borderRadius: '100%' }} onClick={() => navigate('/add-advert')}>
                        <Icon icon={'ri:add-circle-fill'} style={{ height: 28, width: 28 }} />
                    </ButtonBase>
                </div>
                <div className="mt-1 mb-2">
                    <SearchBar
                        value={search}
                        module={'make, model, title, or reg. no'}
                        setValue={(e) => handleSearch(e)}
                    />
                </div>


                <div className="d-flex align-items-center my-3 gap-2" style={{ flexWrap: 'wrap' }}>

                    <PopOverFilter
                        setDialogOpen={setDrawerOpen}
                        open={drawerOpen}
                        applyFilter={applyFilter}
                        filterData={filterList2}
                        setFilterObject={setFilterObject}
                        sort={sort} sort_by={sort_by}
                        handleResetFilter={resetFilter}
                    />
                </div>

                {
                    Array.isArray(advertListing?.data?.data) && advertListing?.data?.data.length > 0 && advertListing?.data?.data.map((item) => {
                        return (
                            <div
                                key={item?.id}
                                className="d-flex align-items-start py-3"
                                style={{ borderBottom: '1px solid #E2E2E2', gap: 10 }}
                                onClick={() => navigate(`/advert/${item?.id}`)}
                            >

                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <div className="d-flex justify-content-between align-items-start gap-2">
                                        <div style={{ minWidth: 0 }}>
                                            <div className="text-bold" style={{ wordBreak: 'break-word' }}>{item?.reference_no || '-'}</div>
                                            <div className="subheader-2 font-size-12">{item?.application_id || '-'}</div>
                                        </div>
                                        <div className="text-semibold" style={{ whiteSpace: 'nowrap' }}>{formatLoanAmount(item?.loan_amount)}</div>
                                    </div>
                                    <div className="mt-2">
                                        <div className="subheader-2 font-size-12">Applicant</div>
                                        <div style={{ wordBreak: 'break-word' }}>{item?.applicant?.name || item?.applicant_name || '-'}</div>
                                    </div>
                                    <div className="mt-2">
                                        <div className="subheader-2 font-size-12">Vehicle</div>
                                        <div style={{ wordBreak: 'break-word' }}>{item?.vehicle || item?.listing_title || '-'}</div>
                                        <div className="subheader-2 font-size-12">{item?.dealer_name || '-'}</div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-start mt-2 gap-3">
                                        <div style={{ minWidth: 0 }}>
                                            <div className="subheader-2 font-size-12">Finance Company</div>
                                            <div style={{ wordBreak: 'break-word' }}>{item?.finance_company || item?.finance_company_name || '-'}</div>
                                        </div>
                                        <div className="text-end" style={{ flex: '0 0 auto' }}>
                                            <div className="subheader-2 font-size-12">Submitted On</div>
                                            <div>{formatSubmittedDate(item?.submitted_at)}</div>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <Label.GeneralStatusLabel label={item?.status} list={Helpers.loanApplicationStatus} marginLeft={"0px"} />
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !advertListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {
                        width <= 768 ? mobileView() :
                            <>
                                {renderHeader()}
                                <AppTab tabValue={tabValue} setTabValue={handleTabChange}
                                    tabList={
                                        isDirectSeller
                                            ? [
                                                ...tabList.slice(0, -1), // Everything except the last 2 items
                                                {
                                                    value: "appealed",
                                                    label: `Appealed (${advertListing?.counts?.appealed || 0})`,
                                                },
                                                {
                                                    value: "rejected",
                                                    label: `Rejected (${advertListing?.counts?.rejected || 0})`,
                                                },
                                                ...tabList.slice(-1), // Last 2 items
                                            ]
                                            : tabList
                                    }
                                />
                                {customToolsBar()}
                                <Table
                                    header={header}
                                    data={advertListing?.data?.data || []}
                                    pageSize={length}
                                    totalPage={advertListing?.data?.last_page || 1}
                                    customToolsBar={true}
                                    sort={sort}
                                    setSorted={setSorted}
                                    sort_by={sort_by}
                                    setSortBy={setSortBy}
                                    onTableRowClick={(row) => setDetailsOpen(true)}
                                />
                            </>
                    }

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={advertListing?.data?.last_page || 1}
                    />

                    <LoanApplicationDetails
                        detailsOpen={detailsOpen}
                        setDetailsOpen={setDetailsOpen}
                        supportDetails={advertListing}
                        values={advertListing}
                        error={{}}
                        setNotification={setNotification}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Advert, Layout, General }) {
    return {
        width: Layout?.currentWidth,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userPermission: Login.permissionArry,
        advertListing: Advert?.advertListing,
        leftSideBarType: Layout.leftSideBarType,
        makeList: General.bike_makes?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        modelList: General.bike_models?.map((x, idx) => ({
            label: x.name,
            value: x.id
        })) || [],
        financeCompanies: General?.finance_companies,
        applicants: General?.dealer_users,
    };
}

export default connect(mapStateToProps)(LoanApplications);
